import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'itpx-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {

  @Input() contentVisible: boolean = false;

  @HostListener('mouseover', ['$event'])
  onMouseOver(event: MouseEvent) {
    this.contentVisible = true;
  }

  @HostListener('mouseout', ['$event'])
  onMouseOut(event: MouseEvent) {
    this.contentVisible = false;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/tooltip/tooltip.component.ts